import { styled as n, Snackbar as m, Button as f, Box as c, Typography as l } from "@mui/material";
import h from "../../temp-lib/assets/icons/icon-ronin.svg.js";
import x from "../../temp-lib/components/share/generic/CloseButton.js";
import b from "../../temp-lib/components/share/next/Image.js";
import w from "../../ui-lib/components/MuiLoading.js";
import { MobileWalletSnackBarMode as o } from "../constants/index.js";
import { useTranslation as M } from "react-i18next";
import { jsxs as r, Fragment as S, jsx as t } from "react/jsx-runtime";
const k = n(m)`
  .MuiSnackbarContent-root {
    display: flex;
    flex-wrap: nowrap;
  }

  .MuiSnackbarContent-action {
    margin-right: 0px;
  }
`, C = n(b)`
  filter: grayscale(100%) brightness(3);
  width: 24px;
  height: 24px;
`, B = n(f)`
  background-color: #1473e9;
  color: white;
  margin-right: 8px;

  :hover,
  :active,
  :focus,
  :visited {
    background-color: #005bd7;
  }
`, y = n(c)`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
`, v = n(l)`
  font-size: 16px;
  font-weight: 700;
`, z = n(l)`
  font-size: 12px;
`, W = n(x)`
  width: 16px;
`, G = ({
  open: g,
  onClose: i,
  onOpenApp: p,
  mode: a,
  loading: s
}) => {
  const {
    t: e
  } = M(), u = /* @__PURE__ */ r(S, {
    children: [/* @__PURE__ */ t(B, {
      onClick: p,
      disabled: s,
      children: s ? /* @__PURE__ */ t(w, {
        loading: !0,
        size: 24
      }) : a === o.Connect ? e("common.button.connect") : e("common.button.sign")
    }), /* @__PURE__ */ t(W, {
      onClick: i
    })]
  }), d = (() => {
    switch (a) {
      case o.Connect:
        return e("wallet.connect_wallet");
      case o.SignMessage:
        return e("wallet.sign_message");
      case o.SignTransaction:
        return e("wallet.sign_transaction");
      default:
        return;
    }
  })();
  return /* @__PURE__ */ t(k, {
    anchorOrigin: {
      vertical: "top",
      horizontal: "center"
    },
    open: g,
    disableWindowBlurListener: !0,
    onClose: i,
    message: /* @__PURE__ */ r(y, {
      children: [/* @__PURE__ */ t(C, {
        src: h.src
      }), /* @__PURE__ */ r(c, {
        children: [/* @__PURE__ */ t(v, {
          children: e("login.general.button.ronin")
        }), /* @__PURE__ */ t(z, {
          children: d
        })]
      })]
    }),
    action: u
  });
};
export {
  G as default
};
//# sourceMappingURL=OpenRoninWalletAppSnackBar.js.map
